import React from "react";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./Badge.module.css";

type Props = {
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
};

export default function Badge({ children, className, onClick, disabled }: Props) {
  return (
    <div
      className={UStyles.classNames(
        styles.badge,
        className,
        onClick && !disabled && styles.interactive,
        disabled && styles.disabled,
      )}
      onClick={!disabled ? onClick : undefined}
    >
      {children}
    </div>
  );
}
